import React from "react";
import { Box, ButtonBase } from "@mui/material";
import ShowChartRoundedIcon from "@mui/icons-material/ShowChartRounded";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import { tokens } from "../../theme";
import type { MainSection } from "../header/headerDesktop";

export const BOTTOM_NAV_HEIGHT = 64;
/** Space the page must leave free under its content (bar + float gap). */
export const BOTTOM_NAV_CLEARANCE = BOTTOM_NAV_HEIGHT + 32;

const ITEMS: { value: MainSection; label: string; icon: React.ReactNode }[] = [
  { value: "lpp", label: "LPP", icon: <ShowChartRoundedIcon /> },
  { value: "reports", label: "Reports", icon: <ArticleOutlinedIcon /> },
  { value: "trading", label: "Trading", icon: <SwapHorizRoundedIcon /> },
];

/** Floating glass tab bar for phones (admins only). */
export const MobileBottomNav: React.FC<{
  value: MainSection;
  onChange: (section: MainSection) => void;
}> = ({ value, onChange }) => (
  <>
  {/* Scrim: content fades out before it reaches the floating bar. */}
  <Box
    aria-hidden
    sx={{
      position: "fixed",
      left: 0,
      right: 0,
      bottom: 0,
      height: "calc(112px + env(safe-area-inset-bottom))",
      zIndex: (theme) => theme.zIndex.appBar - 1,
      pointerEvents: "none",
      background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.78) 55%, #000 100%)",
    }}
  />
  <Box
    component="nav"
    aria-label="Sections"
    sx={{
      position: "fixed",
      left: 16,
      right: 16,
      bottom: "calc(14px + env(safe-area-inset-bottom))",
      height: BOTTOM_NAV_HEIGHT,
      zIndex: (theme) => theme.zIndex.appBar,
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      p: "6px",
      borderRadius: 999,
      bgcolor: "rgba(22,22,24,0.72)",
      backdropFilter: "blur(24px) saturate(160%)",
      WebkitBackdropFilter: "blur(24px) saturate(160%)",
      border: `1px solid ${tokens.borderStrong}`,
      boxShadow: `${tokens.glass.highlight}, 0 20px 50px -12px rgba(0,0,0,0.9)`,
    }}
  >
    {ITEMS.map((item) => {
      const active = item.value === value;
      return (
        <ButtonBase
          key={item.value}
          onClick={() => onChange(item.value)}
          aria-current={active ? "page" : undefined}
          sx={{
            flex: 1,
            height: "100%",
            borderRadius: 999,
            gap: 0.75,
            fontSize: "0.8125rem",
            fontWeight: 700,
            color: active ? "#111" : "text.secondary",
            background: active ? tokens.goldGradient : "transparent",
            boxShadow: active ? "inset 0 1px 0 rgba(255,255,255,0.35)" : "none",
            "& .MuiSvgIcon-root": { fontSize: 19 },
          }}
        >
          {item.icon}
          {item.label}
        </ButtonBase>
      );
    })}
  </Box>
  </>
);

export default MobileBottomNav;
